const ERROR_NAME = "ServerError";

export class ServerError extends Error {
  httpResponseCode: number;

  constructor(message: string, responseCode: number) {
    super(message);
    this.name = ERROR_NAME;
    this.httpResponseCode = responseCode;
  }
}

export const isServerError = (potentialErrorObject: unknown) =>
  potentialErrorObject instanceof Error &&
  potentialErrorObject.name === ERROR_NAME &&
  (potentialErrorObject as ServerError).httpResponseCode >= 500;
